export function validatePhone(number) {
    return /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(number);
}
export function validatePassword(password) {
    return /^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{8,}$/.test(password);
}

export function validateEmail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

export function validateIdentifyCitizenNumber(number) {
    return /^([0-9]{12})$/.test(number);
}

export function validateIdentifyNumber(number) {
    return /^([0-9]{9})$/.test(number);
}

export function validateAccount(account) {
    return /(9704|4839)+([0-9]{12,16})\b/.test(account);
}

export function validateTargetNumber(account) {
    return /^[0-9]{12,16}$/.test(account);
}

export function validatePin4Length(pin) {
    return /^([0-9]{4})$/.test(pin);
}

export function validatePin6Length(pin) {
    return /^([0-9]{6})$/.test(pin);
}

export function validateName(name) {
    return /^[aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆ fFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTu UùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴz]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/.test(name);
}

export function validateSalary(salary) {
    return /^[0-9][0-9]{0,10}$/.test(salary);
}

export function validateCompany(company) {
    return /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/.test(company);
}

export function validateOTP(value) {
    return /^[0-9]{6}$/.test(value);
}

export function validateTransferMessage(message) {
    return /^[ a-zA-Z0-9]{1,200}$/.test(message)
}
